import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import 'firebase/compat/firestore'
import { getAuth } from "firebase/auth"
import firebase from 'firebase/compat/app'



const firebaseConfig = {
  apiKey: "AIzaSyCanF_xHH6HKBKBsxY4rScdB3jTAJYDv7k",
  authDomain: "jaymalharmauliroadways.firebaseapp.com",
  projectId: "jaymalharmauliroadways",
  storageBucket: "jaymalharmauliroadways.appspot.com",
  messagingSenderId: "170700909455",
  appId: "1:170700909455:web:faab770ad9d8d9704139fa",
  measurementId: "G-41S76K1GYF"
};


// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore()
export { firebase };

 

export const auth = getAuth();

export default app;
